import { Component, Input, OnInit } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { FloodForecastUtilsService } from './../flood-forecast-shared/floodForecastUtils.service';

@Component({
  selector: 'app-bottombar-menus',
  templateUrl: './bottombar-menus.component.html',
  styleUrls: ['./bottombar-menus.component.scss']
})
export class BottombarMenusComponent implements OnInit {

  @Input() map: any;
  @Input() layersList: any;

  activeMenu: string;
  bottomBarOpen = false;

  menus = [
    // { title: 'Base Layers', icon: 'mi-dma-applications', application: 'baseLayers' },
    // { title: 'Layers', icon: 'mi-layers', application: 'layerControl' },
    // { title: 'Legends', icon: 'mi-legend-01' },
    // { title: 'Compare', icon: 'mi-compare' },
    // { title: 'Measure', icon: 'mi-measure' },
    // { title: 'Print', icon: 'mi-print-tool' },
    // { title: 'Draw Tool', icon: 'mi-art' }
  ];

  constructor(private ffUtilsService: FloodForecastUtilsService,
    private utils:UtilsService) {
    ffUtilsService.getFloodForecastSelectedSideBarApplication().subscribe(value => {
      this.activeMenu = value;
    });
  }

  ngOnInit() {
  }

  changeComponents(app?: string) {
    this.map.dragging.enable();

    if (this.activeMenu === app) {
      this.activeMenu = null;
      this.bottomBarOpen = !this.bottomBarOpen;
    } else {
      this.activeMenu = app;
      this.bottomBarOpen = false;
    }

    this.ffUtilsService.setFloodForecastSelectedSideBarApplication(this.activeMenu);
  }

  revalidateMap() {
    if (this.map) {
      this.map.invalidateSize();
      this.map.fire('zoomend');
    }
  }

  getDeviceType(){
    return this.utils.getDeviceType();
  }

}
